/**
 * Market currency configuration (UK_EXPANSION_PLAN.md Phase 2).
 * The ONLY place a currency symbol may originate in this dashboard.
 * Defaults are Nigerian, so the existing deployment needs no env changes;
 * the UK deployment sets REACT_APP_CURRENCY_SYMBOL=£ / _CODE=GBP.
 */
export const CURRENCY_SYMBOL = process.env.REACT_APP_CURRENCY_SYMBOL || '₦';
export const CURRENCY_CODE = process.env.REACT_APP_CURRENCY_CODE || 'NGN';

/** `formatCurrency(5000)` → `₦5,000` (grouping via toLocaleString). */
export const formatCurrency = (amount: number, decimals = 0): string =>
  `${CURRENCY_SYMBOL}${amount.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
